export function extractNumericPrice(val) {
  if (val === undefined || val === null) return null;
  if (typeof val === 'object') {
    if (val.value !== undefined) return extractNumericPrice(val.value);
    if (val.amount !== undefined) return extractNumericPrice(val.amount);
    if (val.price !== undefined) return extractNumericPrice(val.price);
    if (val.__value__ !== undefined) return extractNumericPrice(val.__value__);
    return null;
  }
  const normalized =
    typeof val === 'string' ? val.replace(/[^0-9.-]/g, '') : val;
  const num = parseFloat(normalized);
  return Number.isNaN(num) ? null : num;
}

export function getItemPrice(item) {
  const listingType =
    typeof item.listingType === 'string'
      ? item.listingType.toLowerCase()
      : typeof item.listing_type === 'string'
        ? item.listing_type.toLowerCase()
        : null;

  const fields =
    listingType === 'fixedprice'
      ? [
          'buyItNowPrice',
          'price',
          'sold_price',
          'soldPrice',
          'sale_price',
          'salePrice',
          'final_price',
          'finalPrice',
          'currentPrice',
          'current_price',
          'convertedCurrentPrice',
        ]
      : [
          'price',
          'sold_price',
          'soldPrice',
          'sale_price',
          'salePrice',
          'final_price',
          'finalPrice',
          'currentPrice',
          'current_price',
          'convertedCurrentPrice',
          'buyItNowPrice',
        ];

  const prices = [];
  for (const field of fields) {
    if (field in item) {
      const price = extractNumericPrice(item[field]);
      if (price !== null) prices.push(price);
    }
  }

  const nestedPrices = [
    item.sellingStatus?.currentPrice,
    item.sellingStatus?.convertedCurrentPrice,
    item.selling_status?.current_price,
  ]
    .map((value) => extractNumericPrice(value))
    .filter((price) => price !== null);
  prices.push(...nestedPrices);

  return prices.find((price) => price > 0) ?? prices[0] ?? null;
}

export function computeBestPrice(pricedItems = [], activeItems = []) {
  const soldPrices = pricedItems
    .map((item) => getItemPrice(item))
    .filter((p) => typeof p === 'number' && p > 0);

  if (soldPrices.length > 0) {
    const sum = soldPrices.reduce((a, b) => a + b, 0);
    return { price: sum / soldPrices.length, source: 'sold' };
  }

  const buyNowPrices = activeItems
    .filter((item) => {
      const type =
        typeof item.listingType === 'string'
          ? item.listingType.toLowerCase()
          : typeof item.listing_type === 'string'
            ? item.listing_type.toLowerCase()
            : '';
      return type === 'fixedprice' || 'buyItNowPrice' in item;
    })
    .map((item) => {
      if (item.buyItNowPrice !== undefined) {
        return extractNumericPrice(item.buyItNowPrice);
      }
      return getItemPrice(item);
    })
    .filter((p) => typeof p === 'number' && p > 0);

  if (buyNowPrices.length > 0) {
    return { price: Math.min(...buyNowPrices), source: 'buyNow' };
  }

  const auctionPrices = activeItems
    .filter((item) => {
      const bidCount =
        item.bidCount !== undefined
          ? Number(item.bidCount)
          : item.bid_count !== undefined
            ? Number(item.bid_count)
            : 0;
      return bidCount > 0;
    })
    .map((item) => getItemPrice(item))
    .filter((p) => typeof p === 'number' && p > 0);

  if (auctionPrices.length > 0) {
    return { price: Math.min(...auctionPrices), source: 'auction' };
  }

  return { price: null, source: null };
}
